// V4.1.2: Constants - Tüm sabitler burada

export const KUMBARA_TIPLERI = ['İşletme', 'Ev', 'Araç'];
export const KUMBARA_DURUMLARI = ['Dolu', 'Boş', 'Yarım Dolu', 'Hiç Dolmuyor', 'Görünür Değil', 'Hasarlı', 'Kayıp', 'İşletme Kapandı'];

// Varsayılan alanlar (ilk kurulumda eklenecek)
export const VARSAYILAN_ALANLAR = ['İlkadım', 'Canik', 'Tekkeköy', 'Atakum', 'Merkez'];

// Varsayılan şubeler
export const VARSAYILAN_SUBELER = [
  { id: 'merkez', ad: 'Merkez (Genel)', tip: 'Merkez', durum: 'Aktif' },
  { id: 'irsad', ad: 'İrşad Şubesi', tip: 'Şube', durum: 'Aktif' },
  { id: 'isar', ad: 'İsar Şubesi', tip: 'Şube', durum: 'Aktif' }
];

// Logo URL
export const LOGO_URL = '/teklogo.svg';

